/**
 * @generated SignedSource<<3aaf758532709714b499a20e15e5f662>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type consultationPhoneQuery$variables = {
  hubName: string;
};
export type consultationPhoneQuery$data = {
  readonly hubMeta: {
    readonly hub: {
      readonly id: string;
    };
    readonly id: string;
    readonly organization: {
      readonly id: string;
      readonly pharmacyHubs: {
        readonly nodes: ReadonlyArray<{
          readonly hubId: string;
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"PhoneConsultationFragment">;
        }>;
      };
    };
  };
};
export type consultationPhoneQuery = {
  response: consultationPhoneQuery$data;
  variables: consultationPhoneQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubName"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": [
    (v2/*:: as any*/)
  ],
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "pagination",
  "value": {
    "page": 0,
    "pageSize": 100
  }
},
v5 = [
  (v4/*:: as any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hubId",
  "storageKey": null
},
v7 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
},
v8 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "NaiveTime"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "consultationPhoneQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": (v3/*:: as any*/),
              "action": "THROW"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Organization",
              "kind": "LinkedField",
              "name": "organization",
              "plural": false,
              "selections": [
                (v2/*:: as any*/),
                {
                  "alias": null,
                  "args": (v5/*:: as any*/),
                  "concreteType": "PharmacyHubPage",
                  "kind": "LinkedField",
                  "name": "pharmacyHubs",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PharmacyHub",
                      "kind": "LinkedField",
                      "name": "nodes",
                      "plural": true,
                      "selections": [
                        (v2/*:: as any*/),
                        (v6/*:: as any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "PhoneConsultationFragment"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "pharmacyHubs(pagination:{\"page\":0,\"pageSize\":100})"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "consultationPhoneQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": (v5/*:: as any*/),
                "concreteType": "PharmacyHubPage",
                "kind": "LinkedField",
                "name": "pharmacyHubs",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PharmacyHub",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v2/*:: as any*/),
                      (v6/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phone",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "consultationInfo",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "orderBy",
                            "value": [
                              {
                                "field": "DAY_OF_WEEK",
                                "ordering": "ASC"
                              }
                            ]
                          },
                          (v4/*:: as any*/)
                        ],
                        "concreteType": "OpeningHoursPage",
                        "kind": "LinkedField",
                        "name": "openingHours",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OpeningHours",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              (v2/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "dayOfWeek",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "opensAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "closesAt",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "openingHours(orderBy:[{\"field\":\"DAY_OF_WEEK\",\"ordering\":\"ASC\"}],pagination:{\"page\":0,\"pageSize\":100})"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "pharmacyHubs(pagination:{\"page\":0,\"pageSize\":100})"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "41399612178baa0824996e0a4058f2ed",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "hubMeta": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "HubMeta"
        },
        "hubMeta.hub": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Hub"
        },
        "hubMeta.hub.id": (v7/*:: as any*/),
        "hubMeta.id": (v7/*:: as any*/),
        "hubMeta.organization": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Organization"
        },
        "hubMeta.organization.id": (v7/*:: as any*/),
        "hubMeta.organization.pharmacyHubs": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "PharmacyHubPage"
        },
        "hubMeta.organization.pharmacyHubs.nodes": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "PharmacyHub"
        },
        "hubMeta.organization.pharmacyHubs.nodes.consultationInfo": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "String"
        },
        "hubMeta.organization.pharmacyHubs.nodes.hubId": (v7/*:: as any*/),
        "hubMeta.organization.pharmacyHubs.nodes.id": (v7/*:: as any*/),
        "hubMeta.organization.pharmacyHubs.nodes.openingHours": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "OpeningHoursPage"
        },
        "hubMeta.organization.pharmacyHubs.nodes.openingHours.nodes": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "OpeningHours"
        },
        "hubMeta.organization.pharmacyHubs.nodes.openingHours.nodes.closesAt": (v8/*:: as any*/),
        "hubMeta.organization.pharmacyHubs.nodes.openingHours.nodes.dayOfWeek": {
          "enumValues": [
            "MONDAY",
            "TUESDAY",
            "WEDNESDAY",
            "THURSDAY",
            "FRIDAY",
            "SATURDAY",
            "SUNDAY"
          ],
          "nullable": false,
          "plural": false,
          "type": "Weekday"
        },
        "hubMeta.organization.pharmacyHubs.nodes.openingHours.nodes.id": (v7/*:: as any*/),
        "hubMeta.organization.pharmacyHubs.nodes.openingHours.nodes.opensAt": (v8/*:: as any*/),
        "hubMeta.organization.pharmacyHubs.nodes.phone": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "String"
        }
      }
    },
    "name": "consultationPhoneQuery",
    "operationKind": "query",
    "text": "query consultationPhoneQuery(\n  $hubName: String!\n) {\n  hubMeta(by: {name: $hubName}) {\n    id\n    hub {\n      id\n    }\n    organization {\n      id\n      pharmacyHubs(pagination: {page: 0, pageSize: 100}) {\n        nodes {\n          id\n          hubId\n          ...PhoneConsultationFragment\n        }\n      }\n    }\n  }\n}\n\nfragment PhoneConsultationFragment on PharmacyHub {\n  id\n  phone\n  consultationInfo\n  openingHours(pagination: {page: 0, pageSize: 100}, orderBy: [{field: DAY_OF_WEEK, ordering: ASC}]) {\n    nodes {\n      id\n      dayOfWeek\n      opensAt\n      closesAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "99d113c980da9a764ebee75c327cce5c";

export default node;
